import {Injectable, signal} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class DateService {
    currentDate = signal(new Date());
}
